import React from "react";
import { Car } from "phosphor-react";
import Select from "../Inputs/Select";
import Loading from "../Loading/Loading";

export function RangeSelect({
  ranges,
  setRange,
  setModel,
  fetchModels,
  range,
  isFetchingRanges,
  validate,
}) {
  return (
    <Select
      options={ranges?.map((r) => r.range)}
      defaultValue={
        !ranges || ranges?.length === 0
          ? "No ranges"
          : `Select (${ranges?.length})`
      }
      handleChange={(value) => {
        setModel("");
        setRange(value);
        fetchModels(true);
      }}
      value={range}
      prefix={
        isFetchingRanges ? (
          <Loading />
        ) : (
          <Car size={14} weight="regular" color="var(--carter-secondary)" />
        )
      }
      label="Range*"
      id="range"
      validate={validate}
    />
  );
}
